import { render, staticRenderFns } from "./LocationTab.vue?vue&type=template&id=185a96fc&scoped=true"
import script from "./LocationTab.vue?vue&type=script&lang=ts"
export * from "./LocationTab.vue?vue&type=script&lang=ts"
import style0 from "./LocationTab.vue?vue&type=style&index=0&id=185a96fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a96fc",
  null
  
)

export default component.exports